import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import Flatpickr from 'react-flatpickr'
import TetherComponent from 'react-tether'
import moment from 'moment-timezone'
import Label from './../Input/Label'
import './styles.css'
import Icon from '../../Icon/Icon'
import DateTimeRange from '../DateTimeRange/DateTimeRange'

const RANGE_POSITION = 'end'

export default class TimePicker extends Component {
  constructor (props) {
    super(props)

    this.flatpickrRef = React.createRef()
    this.calendarRef = React.createRef()
    this.state = {
      isNearBottom: false
    }
  }

  handleChange = (value) => {
    if (!value) {
      return
    }
    let momentValue = moment(value)
    if (!momentValue.isValid()) {
      const date = new Date('Jan 2, 1970 ' + value)
      momentValue = moment(date.getTime())
      if (!momentValue.isValid()) {
        return
      }
    }
    this.props.onChange(momentValue)
  }

  clearValue = () => {
    this.props.onChange('')
  }

  handleOpen = () => {
    if (this.calendarRef && this.flatpickrRef && this.calendarRef.current && this.flatpickrRef.current) {
      this.calendarRef.current.appendChild(this.flatpickrRef.current.flatpickr.calendarContainer)
    }
    const { bottom } = ReactDOM.findDOMNode(this.trigger).getBoundingClientRect() || {}
    const { innerHeight } = window || {}
    this.setState({
      isNearBottom: innerHeight - bottom < 60
    })
  }

  handleClose = () => {
    if (this.calendarRef && this.calendarRef.current) {
      this.calendarRef.current.removeChild(this.calendarRef.current.childNodes[0])
    }
    this.setState({
      isNearBottom: false
    })
  }

  renderPicker = (props) => {
    const { className, value, required, error, isValid } = this.props
    return (
      <Flatpickr
        ref={this.flatpickrRef}
        value={props.value}
        className={`${className} form-control  ${(isValid && 'is-valid') || ''} ${((error || (required && !value)) && 'is-invalid') || ''}`}
        options={{
          altInputClass: 'form-control',
          dateFormat: 'h:i K',
          enableTime: true,
          allowInput: true,
          noCalendar: true,
          position: 'below',
          static: true,
          time_24hr: false
        }}
        onChange={value => this.handleChange(new Date(value).getTime())}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
      />
    )
  }

  render () {
    const { value, icon, config: { useRange } = {} } = this.props

    return (
      <div className={'time-picker w-100 d-flex input-wrapper'}>
        {
          useRange
            ? <DateTimeRange
                {...this.props}
                timeOnly
                config={{
                  ...this.props.config && { ...this.props.config },
                  rangePosition: RANGE_POSITION
                }}
              />
            : <>
              <Label {...this.props} />
              <div ref={trigger => { this.trigger = trigger }} className={'w-100 d-flex align-items-end position-relative'}>
                <TetherComponent
                  style={{ zIndex: 888, padding: 0 }}
                  attachment='bottom left'
                  targetAttachment='bottom right'
                  targetOffset={this.state.isNearBottom ? '-100px 0' : '4px 0'}
                  renderTarget={ref => <span ref={ref} />}
                  renderElement={ref => {
                    this.calendarRef = ref
                    return <div ref={ref} />
                  }}
                />
                <Fragment>
                  {this.renderPicker(this.props)}
                  {
                    (value || icon) &&
                    <span className={'icon-container'}>
                  <Icon
                    icon={value ? 'close' : icon}
                    onIconClick={this.clearValue}
                    styling={{
                      iconColor: '#cccccc'
                    }}
                    style={{
                      fontSize: '16px',
                      fontWeight: 'bold',
                      lineHeight: '.1rem'
                    }}
                  />
                </span>
                  }
                </Fragment>
              </div>
            </>
        }
        <style jsx>{`
          .time-picker {
            flex-direction: column;
          }
          div .icon-container {
            position: absolute;
            top: 50%;
            right: .15rem;
            cursor: pointer;
            transform: translateY(-45%);
          }
          div :global(.flatpickr-wrapper) {
            width: 100%;
          }
          div :global(.flatpickr-wrapper .flatpickr-calendar) {
            display: none !important;
          }
          div.time-picker :global(.tether-target) {
            padding-left: 0;
            flex: none !important;
          }
          :global(.flatpickr-calendar:before),
          :global(.flatpickr-calendar:after) {
            border: none;
          }
          :global(.flatpickr-time) {
            border-top: none !important;
          }
          `}</style>
      </div>
    )
  }
}
